import {
  ImageLibraryParams,
  LibraryImagesParams,
  LibraryTagsParams,
} from "./types";

export const imageLibraryKeys = {
  all: ["image-library"] as const,
  items: (params: ImageLibraryParams = {}) =>
    [...imageLibraryKeys.all, "items", params] as const,
  images: () => [...imageLibraryKeys.all, "images"] as const,
  imageList: (params: LibraryImagesParams) =>
    [...imageLibraryKeys.images(), "list", params] as const,
  image: (id: number) => [...imageLibraryKeys.images(), "detail", id] as const,
  tags: () => [...imageLibraryKeys.all, "tags"] as const,
  tagList: (params: LibraryTagsParams = {}) =>
    [...imageLibraryKeys.tags(), "list", params] as const,
};
